import {
  AfterContentInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { AppState } from "@store/state";
import { User, Store as TenderCutsStore } from "@tendercuts/models";
import { Constants } from "@app/env";
import { Input } from "@angular/core";
import { take } from "rxjs/operators";
import { ModalController } from "@ionic/angular";
import { Observable } from "rxjs";
import { SaleItem } from "../../../../tendercuts/models/sale-order/sale-item";
import { Store } from "@ngrx/store";
import { UserState } from "@store/user";
import { PosQuote } from "../../../models";
import { CartState } from "@store/cart/state";
import { StoreState } from "@store/store-state/state";
import * as selectors from "@store/state";

@Component({
  selector: "app-invoice",
  templateUrl: "./invoice.page.html",
  styleUrls: ["./invoice.page.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class InvoicePage implements AfterContentInit, OnInit {
  // Diff Envee pos and tendercuts pos
  isEnveePos = false;
  // In test cases mode hide the print popup
  isTestCaseMode = false;
  @Input() posQuote: PosQuote;
  // tendercash amount not showing in order display page print
  @Input() isHistoryBill = false;
  storeAddress: String;
  todayDate = new Date();
  user: User;
  math = Math;
  // showing tax category wise
  categoryTax = [];
  gstNumber: string = "";
  //instant sync mode is used to categorize the product
  @Input() instantSync: boolean = false;
  currentStore: TenderCutsStore;
  storePhoneNo: string;
  fssaiCode: string;

  constructor(
    public modalCtrl: ModalController,
    private store: Store<AppState>,
    public constants: Constants
  ) {}

  ngAfterContentInit() {
    if (!this.isTestCaseMode) {
      setTimeout(() => this.print(), 500);
    }
  }

  ngOnInit() {
    this.fetchTaxAmount();
    this.fetchCurrentStore();
    this.getEnveeUserDetail();
  }

  // Fn to fetch current store detail from redux
  fetchCurrentStore() {
    this.stores.subscribe((state: StoreState) => {
      if (state.store) {
        this.currentStore = state.store;
        this.gstNumber = this.currentStore.storeAttribute.gstNumber;
        this.storeAddress = this.currentStore.address;
        this.storePhoneNo = this.currentStore.phone;
        this.fssaiCode = this.currentStore.storeAttribute.fssaiCode;
      }
    });
  }

  /**
   * To get selected store details
   */
  get stores(): Observable<StoreState> {
    return this.store.select(selectors.getStoreState);
  }

  /**
   * Return true if any one of the virtual product in cart
   */
  get isEliteProductInCart(): boolean {
    return this.posQuote.cartProducts.some(
      (item: SaleItem) => item.isSubscription
    );
  }

  /**
   * showing gst for quote items in category wise.
   */
  fetchTaxAmount() {
    let category: any = {};
    this.posQuote.cartProducts.forEach((item: SaleItem) => {
      if (!category[item.taxPercent]) {
        category[item.taxPercent] = {
          taxPercent: item.taxPercent,
          gst: 0,
          Amount: 0,
        };
        if (category[item.taxPercent].taxPercent <= 0) {
          return;
        }

        this.categoryTax.push(category[item.taxPercent]);
      }

      category[item.taxPercent].gst += item.taxAmount;
      category[item.taxPercent].Amount += item.rowTotalWithDiscount;
      return category;
    });
  }

  /**
   * Fn to check isEnveePos User
   */
  async getEnveeUserDetail() {
    let state = await this.userState.pipe(take(1)).toPromise();
    this.user = state.user;
    this.isEnveePos = state.user.isEnveeUser;
  }

  get displayPaymentMethod() {
    switch (this.posQuote.paymentMethod) {
      case "cashforpos":
        return "CASH";
      case "ccforpos":
        return "CARD";
      case "cp1forpos":
        return "VENDOR PAYMENT";
      default:
        return "";
    }
  }

  /**
   * user available reward points
   */
  get userRewards() {
    let rewards =
      this.posQuote.user.rewards - this.posQuote.totals.rewardPointsSpend;
    return rewards;
  }

  print(): void {
    let printContents, popupWin, elementDom;
    elementDom = document.getElementById("selector");
    printContents = elementDom ? elementDom.innerHTML : "Retry print bill";
    popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=70mm");
    // Handeld sentry log : TYPEERROR: popupWin is null
    if (!popupWin) {
      alert("Enable popup window in browser and then try print bill");
      return;
    }
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <style>
      body {
        height: 100%;
      }
      .container {
        text-align: center;
        width: 70mm;
        padding:0 3%;
        page-break-before: always;
      }
      p {
        margin: 1%;
        font-size: 0.9rem;
        text-align: center;
      }
      .heading h4 {
        font-size: 1.8rem;
      }
      .order-id {
        text-align: center;
      }
      .heading h4 , .order-id h4 {
        font-weight: bolder;
        margin: 1%;
      }
      .vendor-payment {
        text-align: left;
      }
      table {
        margin: 4% 0;
        font-size: 15px;
        text-align: left;
        width: 70mm;
        border-collapse: collapse;
      }

      th {
        height: 25px;
      }

      td {
        height: 20px;
      }

      .text-right {
        text-align: right;
      }
      .tax-data {
        text-align: left;
        font-weight: bold;
        margin: 4% 0;
      }
      .bold {
        font-weight: bold;
        text-align:center;
      }
      .child{
        margin-left: 2rem;
        padding-top: 10px;
      }
      .hsn {
       padding-left: 0.3rem;
      }
    </style>

    <body >${printContents}</body>
    </html>
    `);
    popupWin.document.close();
    popupWin.focus();
    popupWin.print();
    popupWin.close();
  }

  shouldShowComponent(fieldName) {
    if (
      this.posQuote.totals[fieldName] &&
      this.posQuote.totals[fieldName] != 0
    ) {
      return true;
    }
    return false;
  }

  get userState(): Observable<UserState> {
    return this.store.select((state) => state.userState);
  }

  // To get storeState
  get storeState(): Observable<StoreState> {
    return this.store.select((state) => state.storeState);
  }

  /**
   * calculating the total itemsubtotal for actual price
   * return sum of saleitem actualPrice (RATE)
   */
  get itemSubTotal() {
    return this.posQuote.cartProducts.reduce(
      (total: number, item: SaleItem) => total + Math.abs(item.rowTotal),
      0
    );
  }

  /**
   * calculating the total original price for cartproducts item (RATE TOTAL)
   */
  get itemsBaseRowTotal() {
    return this.posQuote.cartProducts.reduce(
      (total: number, item: SaleItem) => total + Math.abs(item.baseRowTotal),
      0
    );
  }
  /**
   * (ITEM Discount TOTAL)
   * calculating promoDiscount with the diffeence between baseRowTotal and row Total
   */
  get promoDiscount() {
    return this.posQuote.cartProducts.reduce(
      (total: number, item: SaleItem) =>
        total + Math.abs(item.baseRowTotal - item.rowTotal),
      0
    );
  }

  /**
   *@param item promo discount for each item
   *( item DISCOUNT )
   *calculating promoDiscount with the diffeence between
   *baseRowTotal and row Total for the item
   */

  itemDiscount(item: SaleItem) {
    return item.baseRowTotal - item.rowTotal;
  }

  /**
   * grossTotal for the order adding itemSubTotal and gstamount
   */
  get grossTotal() {
    return this.itemSubTotal + this.posQuote.totals.taxAmount;
  }

  /**
   * calculation for savings promodiscount + coupon code (discount+rewardpointsspend)
   */
  get totalSavings() {
    let save =
      this.promoDiscount +
      Math.abs(this.posQuote.totals.discount) +
      Math.abs(this.posQuote.totals.rewardPointsSpend);
    return +save;
  }

  /**
   * Instant sync mode - Hit the instant sync api if any combo product in cart.
   * Return only simple items if mode is instant sync or order history bill
   * else return cart products.
   * @param products
   */
  extractProducts(quote: PosQuote) {
    if (this.instantSync || this.isHistoryBill) {
      return quote.cartProducts.filter((item: SaleItem) => item.isSimple);
    }
    return quote.cartProducts;
  }

  /**get cart state */
  get cartState(): Observable<CartState> {
    return this.store.select((state) => state.cartState);
  }
}
